/* GUSTA CUSTOMIZATION: ARTICLE EDITORIAL LAYOUT
 * Progressively repositions native Warehouse article elements into the Gusta-owned
 * editorial layout. Native Warehouse source files remain untouched.
 */
(function () {
  'use strict';

  var stateKey = '__gustaArticleEditorialState';

  function getState() {
    if (!window[stateKey]) {
      window[stateKey] = {};
    }

    return window[stateKey];
  }

  function markMobileShare(articleInner) {
    var labels = articleInner.querySelectorAll('.article__aside-item .article__share-label');
    var index;

    for (index = 0; index < labels.length; index += 1) {
      var item = labels[index].closest('.article__aside-item');

      if (item) {
        item.classList.add('gusta-article-editorial__mobile-share');
      }
    }
  }

  function initGustaArticleLayout() {
    var root = document.querySelector('[data-gusta-article-editorial]');
    var nativeArticle = document.querySelector('[data-section-type="blog-post"]');

    if (!root || !nativeArticle) {
      return;
    }

    var contentSlot = root.querySelector('[data-gusta-article-content-slot]');
    var shareSlot = root.querySelector('[data-gusta-article-share-slot]');
    var articleInner = root.querySelector('.article__inner') || nativeArticle.querySelector('.article__inner');
    var state = getState();

    if (!contentSlot || !articleInner) {
      return;
    }

    if (nativeArticle.contains(articleInner)) {
      state.articlePlaceholder = document.createComment('gusta-article-inner-placeholder');
      articleInner.parentNode.insertBefore(state.articlePlaceholder, articleInner);
    }

    if (!contentSlot.contains(articleInner)) {
      contentSlot.appendChild(articleInner);
    }

    state.articleInner = articleInner;
    markMobileShare(articleInner);

    if (shareSlot) {
      var toolbarCard = shareSlot.querySelector('.card') || nativeArticle.querySelector('.blog-post > .card.hidden-phone');

      if (toolbarCard) {
        if (nativeArticle.contains(toolbarCard)) {
          state.toolbarPlaceholder = document.createComment('gusta-article-toolbar-placeholder');
          toolbarCard.parentNode.insertBefore(state.toolbarPlaceholder, toolbarCard);
        }

        if (!shareSlot.contains(toolbarCard)) {
          shareSlot.appendChild(toolbarCard);
        }

        state.toolbarCard = toolbarCard;
      }
    }

    state.root = root;
    state.nativeArticle = nativeArticle;
    document.body.classList.add('gusta-article-layout-ready');
  }

  function restoreToNative() {
    var state = getState();

    if (state.articleInner && state.articlePlaceholder && state.articlePlaceholder.parentNode) {
      state.articlePlaceholder.parentNode.insertBefore(state.articleInner, state.articlePlaceholder.nextSibling);
    }

    if (state.toolbarCard && state.toolbarPlaceholder && state.toolbarPlaceholder.parentNode) {
      state.toolbarPlaceholder.parentNode.insertBefore(state.toolbarCard, state.toolbarPlaceholder.nextSibling);
    }

    window[stateKey] = {};
    document.body.classList.remove('gusta-article-layout-ready');
  }

  function discardMovedNativeContent() {
    var state = getState();

    if (state.articleInner && state.articleInner.parentNode) {
      state.articleInner.parentNode.removeChild(state.articleInner);
    }

    if (state.toolbarCard && state.toolbarCard.parentNode) {
      state.toolbarCard.parentNode.removeChild(state.toolbarCard);
    }

    window[stateKey] = {};
    document.body.classList.remove('gusta-article-layout-ready');
  }

  function handleSectionUnload(event) {
    var target = event.target;
    var root = document.querySelector('[data-gusta-article-editorial]');

    if (!target || !target.querySelector) {
      return;
    }

    if (target.querySelector('[data-section-type="blog-post"]')) {
      discardMovedNativeContent();
      return;
    }

    if (root && (target === root || target.contains(root))) {
      restoreToNative();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGustaArticleLayout, { once: true });
  } else {
    initGustaArticleLayout();
  }

  document.addEventListener('shopify:section:unload', handleSectionUnload);
  document.addEventListener('shopify:section:load', initGustaArticleLayout);
}());
